// extracted by mini-css-extract-plugin
export default {"iconWrap":"icons_iconWrap__y6tsm","panelIconWrap":"icons_panelIconWrap__LOznM"};